import React from 'react';
import clsx from 'clsx';
import { CardMedia, Theme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Styles } from '@mui/styles/withStyles/withStyles';
import { WithStyles, makeStyles, withStyles } from '@mui/styles';
import { colorPalette } from '@qualifio/ui-commons';
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faTrashClock } from '@fortawesome/pro-solid-svg-icons/faTrashClock';
import LoyaltyPreview from './preview.jpg';

const styles: Styles<Theme, any> = ({ spacing, shape, transitions }: Theme) => {
  const { borderRadius } = shape;
  const transition = transitions.create(['opacity', 'color'], {
    duration: transitions.duration.shorter,
  });

  return {
    root: {
      backgroundColor: colorPalette.marine.main,
      height: 240,
      padding: spacing(2.5, 2.5, 0),
      position: 'relative',
    },
    media: {
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius,
      height: '100%',
      position: 'relative',
      transition,
      zIndex: 0,
      '&:after': {
        background: `linear-gradient(to top, ${colorPalette.marine.main}, transparent)`,
        bottom: 0,
        content: "''",
        display: 'block',
        height: '40%',
        position: 'absolute',
        width: '100%',
      },
    },
    editIcon: {
      alignItems: 'center',
      borderRadius: '100%',
      border: '2px solid white',
      color: 'white',
      display: 'flex',
      fontSize: 20,
      height: 55,
      justifyContent: 'center',
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      transition,
      width: 55,
      zIndex: 1,
    },
  };
};

const useStyles = makeStyles(styles);

type Props = WithStyles<any> & {
  className?: {
    root?: string;
    editIcon?: string;
    media?: string;
  };
  image?: string;
  disabled?: boolean;
  title: string;
};

function LoyaltyItemPreviewComponent({
  className = {},
  title,
  image = LoyaltyPreview,
  disabled = false,
}: Props): React.ReactElement {
  const classes = useStyles({});

  return (
    <div className={clsx(classes.root, className.root)}>
      <div className={clsx(classes.editIcon, className.editIcon)}>
        <FontAwesomeIcon icon={disabled ? faTrashClock : faPen} />
      </div>
      <CardMedia className={clsx(classes.media, className.media)} image={image} title={title} />
    </div>
  );
}

export const LoyaltyItemPreview = withStyles(styles)(LoyaltyItemPreviewComponent);
